import * as React from "react";
import Zebricek from "../../../components/customOrgs/senzacni/Zebricek";
import Layout from "../../../components/customOrgs/senzacni/Layout";
import { Container, Typography } from "@mui/material";

export default function zebricek() {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h4" gutterBottom>
                    Průběžné pořadí ročníku 2021
                </Typography>
                <Zebricek />
            </Container>
        </Layout>
    );
}
